import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import type { GridConfig } from '../models/grid-config';

export const useGridsStore = defineStore('grids-config', () => {
  // state
  const gridConfigs = useLocalStorage<GridConfig[]>('grid/configs', []);

  // getters
  function getGridByName(name: string) {
    return gridConfigs.value.find((gridConfig) => gridConfig.name === name);
  }

  // actions
  function addEditGridConfig(addEditGridConfig: Partial<GridConfig>) {
    const existingTableFilterIndex = gridConfigs.value.findIndex(
      (gridConfig) => gridConfig.name === addEditGridConfig.name,
    );

    let mergedTableFilters: GridConfig[];

    if (existingTableFilterIndex !== -1) {
      mergedTableFilters = gridConfigs.value.slice();
      mergedTableFilters.splice(existingTableFilterIndex, 1, {
        ...gridConfigs.value[existingTableFilterIndex],
        ...addEditGridConfig,
      });
    } else {
      mergedTableFilters = [...gridConfigs.value, addEditGridConfig as GridConfig];
    }

    gridConfigs.value = mergedTableFilters;
  }

  function $reset() {
    gridConfigs.value = [];
  }

  return {
    gridConfigs,
    getGridByName,
    addEditGridConfig,
    $reset,
  };
});
